// models/controleBar/comandas/StatusComanda.js
export const StatusComanda = Object.freeze({
  Aberta: 0,
  ParcialmentePaga: 1,
  Fechada: 2,
  Cancelada: 3,
});

// "IEnumerable" (lista) de opções para combos
export const StatusComandaOptions = [
  { value: -1, label: "Todas" },
  { value: StatusComanda.Aberta, label: "Abertas" },
  { value: StatusComanda.ParcialmentePaga, label: "Parcialmente Paga" },
  { value: StatusComanda.Fechada, label: "Fechadas" },
  { value: StatusComanda.Cancelada, label: "Canceladas" },
];

// helper para mostrar descrição na tabela/prints
export function getStatusComandaLabel(value) {
  const item = StatusComandaOptions.find(x => x.value === value);
  return item?.label || `Status ${value}`;
}
